import { render, staticRenderFns } from "./kalenggahan.vue?vue&type=template&id=24cd1ebe&"
import script from "./kalenggahan.vue?vue&type=script&lang=js&"
export * from "./kalenggahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports